import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/home/home'
import Search from '@/components/search/search'
import Preview from '@/components/content-preview/preview'
import Login from '@/components/login/login'
import Authorship from '@/components/authorship/authorship'
import Errors from '@/components/content-error/errors'
import ShareResource from '@/components/resources/share-resource/share-resource'
import ManageMyResources from '@/components/resources/manage-resources/manage-my-resources'
import ModerateResources from '@/components/resources/moderate-resources/moderate-resources'
import BrokenLink from '@/components/content-error/error-broken-link'
import Notebook from '@/components/notebook/notebook'
import LegacyAccount from '@/components/login/legacy-account'

import { UPLOAD_CONTENT_SMEX } from '@/plugins/feature/feature-list'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/preview/:id',
      name: 'Preview',
      component: Preview,
      props: (route) => ({
        download: route.query.download,
        sharePreview: false
      })
    },
    {
      path: '/share/:id',
      name: 'Share',
      component: Preview,
      props: (route) => ({
        download: route.query.dl,
        sharePreview: true,
        shareNoteBook: route.query.src === 'notebook'
      })
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/authorship/:id',
      name: 'Authorship',
      component: Authorship,
      props: (route, fileName) => ({
        download: route.query.download,
        fileName: fileName
      })
    },
    {
      path: '*',
      name: 'Error',
      component: Errors,
      props: {error: 0, large: 'true'}
    },
    {
      path: '/share-resource',
      name: 'ShareResource',
      component: ShareResource,
      props: (metadata) => ({metadata: metadata}),
      beforeEnter: (to, from, next) => {
        const isUploadEnabled = Vue.prototype.$feature(UPLOAD_CONTENT_SMEX.name).enabled
        if (isUploadEnabled || from.name === 'MyResource') {
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/manage-my-resources',
      name: 'ManageMyResources',
      component: ManageMyResources,
      props: (metadata) => ({metadata: metadata})
    },
    {
      path: '/manage-my-resources/:status',
      name: 'PendingResources',
      component: ManageMyResources,
      props: (route) => ({
        loadState: route.params.status,
        successAlert: route.query.success
      })
    },
    {
      path: '/my-resource/:id',
      name: 'MyResource',
      component: Preview,
      props: () => ({
        resourcePreview: true
      })
    },
    {
      path: '/moderate-resources',
      name: 'ModerateResources',
      component: ModerateResources
    },
    {
      path: '/moderate-resources/:status',
      name: 'ModerateResourcesAndStatus',
      component: ModerateResources,
      props: (route) => ({
        loadState: route.params.status,
        successAlert: route.query.success
      })
    },
    {
      path: '/moderate-resource/:id',
      name: 'ModerateResource',
      component: Preview,
      props: (route) => ({
        contentId: route.params.id,
        resourcePreview: true
      })
    },
    {
      path: '/error/:path',
      name: 'BrokenLink',
      component: BrokenLink,
      props: (route) => ({
        id: route.query.id
      })
    },
    {
      path: '/notebook',
      name: 'Notebook',
      component: Notebook
    },
    {
      path: '/account/sign-up',
      name: 'LegacySignUp',
      component: LegacyAccount
    },
    {
      path: '/account/sign-in',
      name: 'LegacySignIn',
      component: LegacyAccount
    }
  ]
})
